// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-memo {
    overflow: auto;
    resize: vertical;
    width: 100%;

    padding: 0.56rem 1rem;
    font-size: 0.9375rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    border: 1px solid #a9acb4;
    border-radius: 0.25rem;
    margin: 8px 0;
}

.drag-drop-wrapper {
    width: 100%;
    border: 2.5px dashed #ccc;
    border-radius: 16px;
    min-height: 120px;
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/Components/Upload/Upload.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;;IAEX,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":[".upload-memo {\n    overflow: auto;\n    resize: vertical;\n    width: 100%;\n\n    padding: 0.56rem 1rem;\n    font-size: 0.9375rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #495057;\n    border: 1px solid #a9acb4;\n    border-radius: 0.25rem;\n    margin: 8px 0;\n}\n\n.drag-drop-wrapper {\n    width: 100%;\n    border: 2.5px dashed #ccc;\n    border-radius: 16px;\n    min-height: 120px;\n    display: flex;\n    width: 100%;\n    justify-content: center;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
